import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

export default function Obrigado() {
  const navigate = useNavigate();
  useEffect(() => {
    let orderId = null;
    try { orderId = localStorage.getItem("vz_order"); } catch (e) { /* ignore */ }
    const t = setTimeout(() => {
      if (orderId) navigate(`/resultado?order_id=${orderId}`, { replace: true });
      else navigate("/", { replace: true });
    }, 800);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0F0F10] text-[#F5F1E8] flex flex-col items-center justify-center px-6 text-center">
      <Loader2 className="w-10 h-10 animate-spin text-[#C8A46A] mb-5" />
      <h1 className="font-serif text-2xl md:text-3xl">Pagamento recebido! Redirecionando…</h1>
      <p className="text-[#F5F1E8]/60 mt-2">Estamos preparando o seu Estudo Profissional de Visagismo.</p>
    </div>
  );
}
